import { createSlice } from '@reduxjs/toolkit';

const initialDeal = {
    bundleDealCache: {}, // Stores cached bundle deals with the API URL as the key
    similarOffers: {}, // Stores cached similar deals with the API URL as the key
    monthOffers: {}, // Stores cached month deals with the API URL as the key
    brandOffers: {}, // Stores cached brand deals with the API URL as the key
    topOffers: {}, // Stores cached top deals with the API URL as the key
    financeOffers: {}, // Stores cached financial deals with the API URL as the key
    externalOffers: {}, // Stores cached external deals with the API URL as the key
    moveInOffers: {}, // Stores cached moveIn deals with the API URL as the key
    benefitsOffers: {}, // Stores cached benefits deals with the API URL as the key
    digitalAmenities: {}, // Stores cached digitalAmenities deals with the API URL as the key
    bundleOffers: {}, // Stores cached bundleOffers deals with the API URL as the key
    electronicOffers: {},
    homeOffers: {},
    isRefreshRewards: false,
    isCartModalVisible: false,
    showRewardsModal: false,
    isKycModalEnabled: false // To open kyc modal
};

const dealsSlice = createSlice({
    name: 'deals',
    initialState: initialDeal,
    reducers: {
        saveBundleDeals(state, action) {
            const { url, deals } = action.payload;
            state.bundleDealCache[url] = deals;
        },
        clearBundleDealsCache(state) {
            state.bundleDealCache = {};
        },
        removeBundleDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.bundleDealCache[url];
        },
        saveSimilarDeals(state, action) {
            const { url, deals } = action.payload;
            state.similarOffers[url] = deals;
        },
        clearSimilarDealsCache(state) {
            state.similarOffers = {};
        },
        removeSimilarDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.similarOffers[url];
        },
        saveOfferOfMonthDeals(state, action) {
            const { url, deals } = action.payload;
            state.monthOffers[url] = deals;
        },
        clearOfferOfMonthDealsCache(state) {
            state.monthOffers = {};
        },
        removeOfferOfMonthDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.monthOffers[url];
        },
        saveSameBrandOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.brandOffers[url] = deals;
        },
        clearSameBrandOffersDealsCache(state) {
            state.brandOffers = {};
        },
        removeSameBrandOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.brandOffers[url];
        },
        saveTopOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.topOffers[url] = deals;
        },
        clearTopOffersDealsCache(state) {
            state.topOffers = {};
        },
        removeTopOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.topOffers[url];
        },
        saveFinanceOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.financeOffers[url] = deals;
        },
        clearFinanceOffersDealsCache(state) {
            state.financeOffers = {};
        },
        removeFinanceOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.financeOffers[url];
        },
        saveExternalOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.externalOffers[url] = deals;
        },
        clearExternalOffersDealsCache(state) {
            state.externalOffers = {};
        },
        removeExternalOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.externalOffers[url];
        },
        saveMoveInOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.moveInOffers[url] = deals;
        },
        clearMoveInOffersDealsCache(state) {
            state.moveInOffers = {};
        },
        removeMoveInOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.moveInOffers[url];
        },
        saveBenefitsoffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.benefitsOffers[url] = deals;
        },
        clearBenefitsOffersDealsCache(state) {
            state.benefitsOffers = {};
        },
        removeBenefitsOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.benefitsOffers[url];
        },
        saveDigitalAmenitiesDeals(state, action) {
            const { url, deals } = action.payload;
            state.digitalAmenities[url] = deals;
        },
        clearDigitalAmenitiessDealsCache(state) {
            state.digitalAmenities = {};
        },
        removeDigitalAmenitiesDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.digitalAmenities[url];
        },
        saveBundleOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.bundleOffers[url] = deals;
        },
        clearBundleOfferssDealsCache(state) {
            state.bundleOffers = {};
        },
        removeBundleOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.bundleOffers[url];
        },
        saveElectronicOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.electronicOffers[url] = deals;
        },
        clearElectronicOffersDealsCache(state) {
            state.electronicOffers = {};
        },
        removeElectronicOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.electronicOffers[url];
        },
        saveHomeOffersDeals(state, action) {
            const { url, deals } = action.payload;
            state.homeOffers[url] = deals;
        },
        clearHomeOffersDealsCache(state) {
            state.homeOffers = {};
        },
        removeHomeOffersDealsByUrl(state, action) {
            const { url } = action.payload;
            delete state.homeOffers[url];
        },
        // Clear all Cache
        clearAllCaches(state) {
            state.bundleDealCache = {};
            state.similarOffers = {};
            state.monthOffers = {};
            state.brandOffers = {};
            state.topOffers = {};
            state.financeOffers = {};
            state.externalOffers = {};
            state.moveInOffers = {};
            state.benefitsOffers = {};
            state.digitalAmenities = {};
            state.bundleOffers = {};
        },
        // Action to refresh rewards
        setIsRewardRefreshing(state, action) {
            state.isRefreshRewards = action.payload;
        },
        // Action to set open cart modal
        setCartModalVisible(state, action) {
            state.isCartModalVisible = action.payload;
        },
        // Action to set open Rewardsmodal
        setShowRewardsModal(state, action) {
            state.showRewardsModal = action.payload;
        },
        // Action to set open cart modal
        setKycModalEnabled(state, action) {
            state.isKycModalEnabled = action.payload;
        }
    }
});

export const dealAction = dealsSlice.actions;
export default dealsSlice;
